let myIndex = 0;
$(function () {
    if ($('#builders_new_page').length) {
        $(":input").inputmask();
        $("#txtPhone").inputmask({ "mask": "(999) 999-9999" });

        $('#modal-buildersend').keypress(function (e) {
            if (e.keyCode == 13) {
                $('#btnBuilderSendEmail').click();
            }
        });

        $('#btnBuilderSendEmail').click(function (e) {
            e.preventDefault();
            $("#modalsend_ll").validate();
            if ($('#modalsend_ll').valid()) {
                var form = new FormData();
                form.append("FirstName", $("#txtFirstName").val());
                form.append("LastName", $("#txtLastName").val());
                form.append("Email", $("#txtEmailBuilder").val());
                form.append("Phone", $("#txtPhone").val());
                form.append("Company", $("#txtCompany").val());
                form.append("Message", $("#txaMessage").val());
                if (!validateEmail1($("#txtEmailBuilder").val())) {
                    $('#txtEmailBuilder').focus();
                    alert("Invalid Email Address");
                    return false;
                }

                $.ajax({
                    url: "/partners/builders/success",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                        if (response == "ok") {
                            $("#modal-buildersend").modal("hide");
                            $("#modal-buildersuccess").modal("show");
                        }
                    }
                });
            }
            else {
                return false;
            }
        });

        function validateEmail1(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        };

        const scrollers = document.querySelectorAll(".scroller");

        addAnimation();
        function addAnimation() {
            scrollers.forEach((scroller) => {
                scroller.setAttribute("data-animated", true);

                const scrollerInner = scroller.querySelector(".scroller__inner");
                const scrollerContent = Array.from(scrollerInner.children);

                scrollerContent.forEach((item) => {
                    const duplicatedItem = item.cloneNode(true);
                    duplicatedItem.setAttribute("aria-hidden", true);
                    scrollerInner.appendChild(duplicatedItem);
                });
            });
        }

        const carousel = document.querySelector('.carousel');
        const carouselItems = document.querySelectorAll('.carousel-item-n');
        const prevButton = document.querySelector('.carousel-prev');
        const nextButton = document.querySelector('.carousel-next');
        const screenWidth1 = window.innerWidth;
        let currentIndex = 0;
        let itemsPerPage = 3; // Number of items per page in desktop mode
        if (screenWidth1 < 768) {
            itemsPerPage = 1; // Switch to 1 item per page in mobile mode
        }
        if (screenWidth1 >= 768 && screenWidth1 < 1920) {
            itemsPerPage = 2; // Switch to 1 item per page in mobile mode
        }
        if (currentIndex == 0) {
            prevButton.classList.add('notdisplay');
        }
        else {
            prevButton.classList.remove('notdisplay');
        }
        myIndex = currentIndex;
        function showItems() {
            const screenWidth = window.innerWidth;
            if (currentIndex == 0) {
                prevButton.classList.add('notdisplay');
                $(".carousel-container").css('margin-left', '0');
            }
            else {
                prevButton.classList.remove('notdisplay');
                if (screenWidth >= 1280 && screenWidth < 1440) {
                    $(".carousel-container").css('margin-left', '100px');
                }
                if (screenWidth >= 1440 && screenWidth < 1920) {
                    $(".carousel-container").css('margin-left', '120px');
                }
                if (screenWidth >= 1920 && screenWidth < 2560) {
                    $(".carousel-container").css('margin-left', '100px');
                }
                if (screenWidth >= 2560) {
                    $(".carousel-container").css('margin-left', '110px');
                }
            }
            itemsPerPage = 3;
            if (screenWidth < 768) {
                itemsPerPage = 1; // Switch to 1 item per page in mobile mode
            }
            if (screenWidth >= 768 && screenWidth < 1920) {
                itemsPerPage = 2; // Switch to 1 item per page in mobile mode
            }
            let itemsToShow = itemsPerPage;
            const startIndex = currentIndex * itemsToShow;
            const endIndex = startIndex + itemsToShow;
            carouselItems.forEach((item, index) => {
                if (index >= startIndex && index < endIndex) {
                    item.style.display = 'block';
                    item.classList.remove('shadow'); // Remove shadow from visible items
                } else {
                    item.style.display = 'none';
                    if (index === endIndex) {
                        item.style.display = 'block';
                        item.classList.add('shadow'); // Add shadow to the next item
                    }
                }
            });
        }
        function moveNext() {
            const numItems = carouselItems.length;
            const maxIndex = Math.ceil(numItems / itemsPerPage) - 1;
            if (currentIndex < maxIndex) {
                currentIndex++;
                showItems();
                currentSlide(currentIndex);
            }
        }
        function movePrev() {
            if (currentIndex > 0) {
                currentIndex--;
                showItems();
                currentSlide(currentIndex);
            }
        }

        nextButton.addEventListener('click', moveNext);
        prevButton.addEventListener('click', movePrev);

        showItems();
        currentSlide(currentIndex);

        $("span.dots").click(function (e) {
            var i = $(this).attr("data-index");
            currentSlide(i);
        });

        function currentSlide(n) {
            SlideShow(currentIndex = n);
        }

        function SlideShow(n) {
            var i;
            var slides = document.getElementsByClassName("carousel-item-n");
            var m = document.getElementById("#mob")
            var circles;
            if($('#mob:visible').length != 0)
            {
                var m = document.getElementById("mob");
                circles = m.getElementsByClassName("dots");
            }
            if ($('#tab:visible').length != 0) {
                var t = document.getElementById("tab");
                circles = t.getElementsByClassName("dots");
            }
            if ($('#web:visible').length != 0) {
                var w = document.getElementById("web");
                circles = w.getElementsByClassName("dots");
            }

            if (n > slides.length) { currentIndex = 1 }
            if (n < 1) { currentIndex = slides.length }

            for (i = 0; i < circles.length; i++) {
                circles[i].classList.remove("enable");
            }

            circles[n].classList.add("enable");
            currentIndex =  n;
            showItems();
        }
    }
});
